import { watch, useContext } from '@nuxtjs/composition-api';

export const useRoutePathChange = (callback) => {
  const { route, from } = useContext();

  watch(
    () => route.value.path,
    async (newValue, oldValue) => {
      if (newValue && oldValue && newValue === oldValue) return null;

      if (from.value && newValue !== from.value.fullPath) {
        callback();
      }

      return null;
    },
    { immediate: true, deep: true },
  );
};
